---
title: Set up a video avatar
summary: Give a persona a video avatar with Tavus or Anam, and choose who runs the conversation.
visibility: authenticated
feature: avatars
audience: author-admin
section: How-to
order: 62
last_verified: 2026-07-21
owner: docs
---

# Set up a video avatar

An avatar persona appears as a talking video. You configure it on the **Presentation** tab
of **Persona Settings**, alongside the voice settings.

## 1. Switch to avatar mode

On the persona's card, open the **⋯** menu and choose **Settings…**. In **Persona
Settings**, go to **Presentation** and choose **Avatar**. Both the voice configuration and
an avatar configuration section appear — an avatar speaks, so its voice still matters (see
[Set up voice](/help/how-to/voice-setup)).

## 2. Choose a provider

- **Tavus** — set the **Replica ID** of the avatar you want to use (required for Tavus).
- **Anam** — set the Anam **avatar**, **voice**, and (optionally) **LLM** identifiers.

The provider you choose needs a corresponding API key
(see [Manage credentials](/help/how-to/manage-credentials)).

## 3. Choose who runs the conversation

**Avatar Intelligence** decides which system generates the avatar's replies:

- **Provider AI** (Tavus AI or Anam AI) — the avatar provider's own model drives the
  conversation.
- **Expert RAG** — this product's RAG engine drives the conversation, so the avatar answers
  from your persona's knowledge base with citations, just like the chat experience.

Choose **Expert RAG** when you want the avatar grounded in your documents; choose the
provider's AI when you want the provider to handle the dialogue.

## 4. Save and try it

Click **Save Changes** and start a conversation with the persona to see the avatar connect
and respond.

## See also

- [Persona configuration reference](/help/reference/persona-config) — every avatar field.
- [How RAG works here](/help/concepts/how-rag-works) — what *Expert RAG* pipeline mode uses.
